// extracted by css-extract-rspack-plugin
export default {"menuGroup":"IGFcyWSQXZ8PrKfp"};